import { Policy } from 'types/Settings'

export function listToCsvString(list: Policy[], selectorFn: any, header: string): string {
  return list.reduce(selectorFn, header)
}
